import React from 'react';
import { Field, reduxForm } from 'redux-form';
import { Alert, Form, Row, Col, ControlLabel } from 'react-bootstrap';
import { TimeInput, DateInput, Input } from '../../common/components/formControls';
import validators from '../../common/services/validators';
import { withTranslation } from 'react-i18next';

const NewSessionDateForm = ({ error, handleSubmit, pristine, submitSucceeded, initialValues, t }) => {
	return (
		<Form horizontal onSubmit={handleSubmit}>
			{error && <Alert bsStyle='danger'>{error}</Alert>}
			{submitSucceeded && pristine && <Alert bsStyle='success'>{t('Common_UpdateSuccess')}</Alert>}
			<Row className='invisible'>
				<Field name='weekId' component={Input} type='hidden' />
			</Row>
			<DateInput name='date' label={t('Workshop_Session_Date')} validators={validators.required} required horizontal />
			<Row>
				<Col componentClass={ControlLabel} sm={2}>
					{t('Workshop_Morning')}
				</Col>
				<Col sm={5}>
					<TimeInput name='morningStartTime' label={t('Workshop_StartTime')} horizontal labelCol={4} valueCol={8}/>
				</Col>
				<Col sm={5}>
					<TimeInput name='morningEndTime' label={t('Workshop_FinishTime')} horizontal labelCol={4} valueCol={8}/>
				</Col>
			</Row>
			<Row>
				<Col componentClass={ControlLabel} sm={2}>
					{t('Workshop_Afternoon')}
				</Col>
				<Col sm={5}>
					<TimeInput name='afternoonStartTime' label={t('Workshop_StartTime')} horizontal labelCol={4} valueCol={8}/>
				</Col>
				<Col sm={5}>
					<TimeInput name='afternoonEndTime' label={t('Workshop_FinishTime')} horizontal labelCol={4} valueCol={8}/>
				</Col>
			</Row>
		</Form>
	);
};

export default reduxForm({ form: 'newSessionDate' })(withTranslation()(NewSessionDateForm));